import {DataGridEnterprise} from "@cjdev-internal/visual-stack-x/DataGridEnterprise";
import "./style/CampaignsDataTable.css"
import {useCampaignsContext} from "../CampaignsContext/useCampaignsContext";
import * as appConstant from "../../constants/appConstant";
import {CAMPAIGN_DATAGRID_CAPTION, CAMPAIGN_DATAGRID_TITLE, DATATABLE_LICENSE_KEY} from "../../constants/appConstant";
import {useMemo} from "react";
import {FlexPage} from "@cjdev-internal/visual-stack-x/FlexPage";

const CampaignsDataTable = (columns, openModalDialog, searchPanel) => {
    return function CampaignsDataTable({values}) {

        const {selectedColumns, setSelectedColumns, campaignsDataGridState, setCampaignsDataGridState} = useCampaignsContext();
        const defaultColDef = {
            filterParams: {
                buttons: ['reset', 'apply'],
            },
            sortingOrder: ['asc', 'desc'],
            resizable: true,
            wrapHeaderText: true,
            autoHeaderHeight: true
        };

        const rowActions = useMemo(() => [
            {
                label: appConstant.EDIT_PLACEMENT,
                onClick: ({rowData}) => {
                    openModalDialog(appConstant.PLACEMENT_MODE_EDIT, rowData);
                }
            },
            {
                label: appConstant.DUPLICATE_PLACEMENT,
                onClick: ({rowData}) => {
                    openModalDialog(appConstant.PLACEMENT_MODE_DUPLICATE, rowData);
                }
            },
            {
                label: appConstant.REMOVE_PLACEMENT,
                onClick: ({rowData}) => {
                    openModalDialog(appConstant.PLACEMENT_MODE_REMOVE, rowData);
                }
            }
        ], [])
        const saveColumnsState = (e) => {
            const selectedValues = new Set(e.columnApi.columnModel.getAllDisplayedColumns().map((col) => {
                return col.getColId();
            }));
            setSelectedColumns({value: selectedValues, state: e.columnApi.getColumnState()});
        }

        const saveFilterState = (e) => {
            setCampaignsDataGridState(prevState => ({...prevState, filterModel: e.api.getFilterModel()}))
        }

        const onPaginationChange = (e) => {
            setCampaignsDataGridState(prevState => ({...prevState, rowsPerPage: e.api.paginationGetPageSize()}))
        }

        return (
            <div className={"campaign-datatable"}>
                <FlexPage heightAdjust="32px">
                    <DataGridEnterprise
                        rowData={values}
                        columnDefs={columns}
                        getRowId={(data) => data.id}
                        EXPLICIT_ENTERPRISE_AUTH_DO_NOT_USE_WITHOUT_PERMISSION={true}
                        suppressContextMenu={true} //to suppress context menu of copy,excel download
                        onColumnVisible={saveColumnsState}
                        rowActions={rowActions}
                        onSortChanged={saveColumnsState}
                        onFilterChanged={saveFilterState}
                        onColumnMoved={saveColumnsState}
                        onColumnPinned={saveColumnsState}
                        onPaginationChanged={onPaginationChange}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={campaignsDataGridState.rowsPerPage}
                        onGridReady={(params) => {
                            params.api.setQuickFilter(campaignsDataGridState.quickFilterValue);
                            params.api.setFilterModel(campaignsDataGridState.filterModel);
                            if (selectedColumns.state)
                                params.columnApi.applyColumnState({
                                    state: selectedColumns.state,
                                    applyOrder: true,
                                })
                        }}
                        topPanel={searchPanel}
                        title={CAMPAIGN_DATAGRID_TITLE}
                        caption={CAMPAIGN_DATAGRID_CAPTION}
                        licenseKey={DATATABLE_LICENSE_KEY}
                    />
                </FlexPage>
            </div>
        )
    }
}

export default CampaignsDataTable;